import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFilterType } from '@sb-tools/typescript/enums/date-filter-type.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'dateFilterTypeName' })
export class DateFilterTypeNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    // todo: do we need this enum? and dropdown in filter because it hs only one value
    transform(dateFilterType: DateFilterType): string {
        switch (dateFilterType) {
            case DateFilterType.none:
                return this.translateService.instant('All');
            case DateFilterType.withinTheLast:
                return this.translateService.instant('Within the last');
            case DateFilterType.moreThan:
                return this.translateService.instant('More than');
            case DateFilterType.between:
                return this.translateService.instant('Between');
            default:
                return this.translateService.instant('Unknown filter type');
        }
    }
}
